<div data-test="pcLSAXKi" class="subheader__tabs">
  <div data-test="muTwDQWS" class="tabs" [ngClass]="tabsClasses">
    <div data-test="Lj1EVnl-" class="tabs__wrap">
      <div data-test="LBgghF6I" class="tabs__line" #line></div>
      <ng-content></ng-content>
    </div>
  </div>
</div>
